module.exports = __webpack_public_path__ + "static/media/image_right_arrow_selection.9ab97ef6.png";